"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterTabs = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
require("./FilterTabs.scss");
var react_router_dom_1 = require("react-router-dom");
var FilterTabs = function (props) { return (react_1.default.createElement("div", { className: "filter-tabs field has-addons" },
    props.view === 'inbox' &&
        react_1.default.createElement("p", { className: "control" },
            react_1.default.createElement(react_router_dom_1.Link, { to: "/dash", className: classnames_1.default('button', 'has-text-info', { 'is-active': props.activeTab === 'new' }) }, "New Packages")),
    props.view === 'history' &&
        react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("p", { className: "control" },
                react_1.default.createElement(react_router_dom_1.Link, { to: "/dash/packages/history/received", className: classnames_1.default('button', 'has-text-info', { 'is-active': props.activeTab === 'received' }) }, "Received")),
            react_1.default.createElement("p", { className: "control" },
                react_1.default.createElement(react_router_dom_1.Link, { to: "/dash/packages/history/sent", className: classnames_1.default('button', 'has-text-info', { 'is-active': props.activeTab === 'sent' }) }, "Sent"))))); };
exports.FilterTabs = FilterTabs;
